// Module
var code = `<div class="form-group"> <label> <span translate>Transaction Id</span> <input ng-model="currentPayment.offlineCreditCard.transactionId" type="text" class="form-control"/> </label> </div> `;
// Exports
var _module_exports =code;;
var path = '/scripts/directives/payment/paymentMethods/creditCardOffline.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;